import React from "react";
import { DateUtils, ITaskRunner } from "@singularsystems/neo-core";
import { Neo, NeoGrid } from "@singularsystems/neo-react";
import TaxSummaryVM from "./TaxSummaryVM";
import { observer } from "mobx-react";
import TaxSummaryLookup from "../Models/Lookups/TaxSummaryLookup";
import { TextConstants } from "../../../Common/TextConstants";

interface ITaxSummaryProps {
  taskRunner?: ITaskRunner;
  viewModel: TaxSummaryVM;
}

@observer
export default class TaxSummary extends React.Component<ITaxSummaryProps> {
  constructor(props: ITaxSummaryProps) {
    super(props);
  }

  public render() {
    const viewModel = this.props.viewModel;
    return (
      <>
      <Neo.Card>
       {this.props.viewModel.taxSummaryPageManager.totalRecords > 0 &&

            <div className="inner-container">
              <Neo.Pager
                pageManager={viewModel.taxSummaryPageManager}
                pageControlProps={{ pageSizeLabel: "Show" }}
              >
                <div className="horizontalScroll inner-container">
                  <NeoGrid.Grid<TaxSummaryLookup> className={"table-striped"}>
                    {(item, meta) => (
                        <NeoGrid.Row key={item.clientNumber}>
                          <NeoGrid.Column label={TextConstants.Labels.HoldingReportingDate} >
                          {DateUtils.format(item.holdingReportingDate, TextConstants.DateFormats.dateMonthYear)}
                          </NeoGrid.Column>
                          <NeoGrid.Column display={meta.clientNumber} label={TextConstants.Labels.ClientNumber} />
                          <NeoGrid.Column display={meta.clientName}   label={TextConstants.Labels.ClientName} />
                          <NeoGrid.Column display={meta.brokerAccountNumber} label={TextConstants.Labels.BrokerAccountNumber} />
                          <NeoGrid.Column display={meta.brokerAccountCurrency} label={TextConstants.Labels.BrokerAccountCurrency} />
                          <NeoGrid.Column display={meta.realisedGainOrLoss} label={TextConstants.Labels.RealisedGainOrLossAccountCurrency} />
                          <NeoGrid.Column display={meta.incomeDeclared} label={TextConstants.Labels.IncomeDeclaredAccountCurrency} />
                          <NeoGrid.Column display={meta.dividendsDeclared} label={TextConstants.Labels.DividendsDeclaredAccountCurrency}/>
                          <NeoGrid.Column display={meta.dividendsWithholdingTax} label={TextConstants.Labels.DividendWithholdingTaxAccountCurrency} />
                          <NeoGrid.Column display={meta.interestWithholdingTax} label={TextConstants.Labels.InterestWithholdingTaxAccountCurrency} />
                          <NeoGrid.Column display={meta.realisedGainOrLossNC} label={TextConstants.Labels.RealisedGainOrLossNC} />
                          <NeoGrid.Column display={meta.unrealisedGainOrLossNC} label={TextConstants.Labels.UnrealisedGainOrLoss} />
                          <NeoGrid.Column display={meta.incomeDeclaredNC} label={TextConstants.Labels.IncomeDeclaredNC} />
                          <NeoGrid.Column display={meta.dividendsDeclaredNC} label={TextConstants.Labels.DividendsDeclaredNC} />
                          <NeoGrid.Column display={meta.dividendsWithholdingTaxReportedNC} label={TextConstants.Labels.DividendsWithholdingTaxReportedNC} />
                          <NeoGrid.Column display={meta.interestWithholdingTaxReportedNC} label={TextConstants.Labels.InterestWithholdingTaxReportedNC} />
                          <NeoGrid.Column display={meta.provisionalCGTValueNC} label={TextConstants.Labels.ProvisionalCGTValueNC} />
                          <NeoGrid.Column display={meta.provisionalIWTValueNC} label={TextConstants.Labels.ProvisionalIWTValueNC} />
                          <NeoGrid.Column display={meta.provisionalDWTValueNC} label={TextConstants.Labels.ProvisionalDWTValueNC} />
                        </NeoGrid.Row>
                     )}
                  </NeoGrid.Grid>
                </div>
              </Neo.Pager>
            </div>
          }
            {viewModel.taxSummaryPageManager.totalRecords <= 0 && (
              <div className="col-md-12 p-0 text-center">
                {TextConstants.GeneralText.NoRecords}
              </div>
            )}
          </Neo.Card>
      </>
    );
  }
}